import React from "react";
import { Link } from "react-router-dom";
import { blogData } from "../../blogs";
import { getTopic } from "../../utils/config";
import { BlogText } from "./blogs.styled";
const TopicNavigation = ({ index }) => {
  return (
    <BlogText style={{ fontWeight: "bold" }}>
      {blogData[index].pillarTopic ? (
        <Link style={{ color: "#353535" }} to={`/blogs/${getTopic(blogData[index].pillarTopic)}`}>
          {blogData[index].pillarTopic}
        </Link>
      ) : (
        "" + " "
      )}

      {/* {blogData[index].subTopic ? (
            <Link
              style={{ color: "#353535" }}
              to={`/blogs/${blogData[index].pillarTopic}/${blogData[index].subTopic}`}
            >
              {" / " + blogData[index].subTopic}
            </Link>
          ) : (
            ""
          )} */}
    </BlogText>
  );
};

export default TopicNavigation;
